export default __webpack_public_path__ + "static/media/realstate.f650ea8a.PNG";